import { debug as baseDebug } from '@skinsoft/debug';
import { Subject } from 'rxjs';
import { buffer, debounceTime, filter, map, tap } from 'rxjs/operators';

const debug = baseDebug('keyboard$');

export const input$ = new Subject();

export const keyboard$ = input$.pipe(
    buffer(input$.pipe(debounceTime(300))), // should be under 100 to avoid user perceives the app as laggy but barcode reader is too slow
    filter(chars => chars.length > 0),
    map(chars => chars.join('').trim()), // we trim to remove extra line break added by the barcode reader
    tap(input => debug('input', input)),
);
